import { OrderStep } from "../../constants";
import useStoreOrderData from "../storage/useStoreOrderData";
import useCheckOfferAvailable from "./useCheckOfferAvailable";
import useCountriesToLoader from "./useCountriesToLoader";
import useExpireOrder from "./useExpireOrder";
import usePrefillData from "./usePrefillData";
import useRedirectOnInvalidOrder from "./useRedirectOnInvalidOrder";
import useScrollToError from "./useScrollToError";
import useSetIsInitialDataLoaded from "./useSetIsInitialDataLoaded";
import useUpdateCountryNames from "./useUpdateCountryNames";
import useUpdateCoupon from "./useUpdateCoupon";
import useUpdateIsDomestic from "./useUpdateIsDomestic";
import useUpdateIsFromOriginCountry from "./useUpdateIsFromOriginCountry";
import useUpdateIsIntraEurope from "./useUpdateIsIntraEurope";
import useUpdateOfferGroupId from "./useUpdateOfferGroupId";
import useUpdatePrices from "./useUpdatePrices";
import useUpdateStepsByDeliveryMethod from "./useUpdateStepsByDeliveryMethod";

const useCommonOrderSideEffects = (step: OrderStep): void => {
  usePrefillData();
  useUpdateOfferGroupId();
  useUpdateStepsByDeliveryMethod();
  useStoreOrderData();
  useCountriesToLoader();
  useCheckOfferAvailable();
  useUpdateCountryNames();
  useUpdateIsDomestic();
  useUpdateIsIntraEurope();
  useUpdateIsFromOriginCountry();
  useUpdatePrices();
  useUpdateCoupon();
  useExpireOrder();
  useRedirectOnInvalidOrder(step);
  useSetIsInitialDataLoaded();
  useScrollToError();
};
export default useCommonOrderSideEffects;
